<div class="meter-selection-container">
  <!-- <button mat-button (click)="test()">Test</button> -->

  <form [formGroup]="meterForm">
    <!-- Search Type Selection -->
    <div class="search-type-section">
      <h4>How would you like to add for your meter?</h4>
      <mat-radio-group formControlName="searchType" class="search-type-radio">
        <mat-radio-button value="postcode">Search by Postcode</mat-radio-button>
        <mat-radio-button value="mpan">Search by MPAN</mat-radio-button>
        <mat-radio-button value="file">Upload File</mat-radio-button>
      </mat-radio-group>
    </div>

    <!-- Postcode Search -->
    <div formGroupName="postcodeSearch" class="search-section" *ngIf="meterForm.get('searchType')?.value === 'postcode'">
      <h4>Address Search</h4>
      
      <div class="form-row">
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>Postcode</mat-label>
          <input matInput formControlName="postcode" placeholder="Enter postcode">
          <mat-error *ngIf="meterForm.get('postcodeSearch.postcode')?.hasError('required')">
            Postcode is required
          </mat-error>
          <mat-error *ngIf="meterForm.get('postcodeSearch.postcode')?.hasError('minlength')">
            Postcode must be at least 6 characters
          </mat-error>
          <mat-error *ngIf="meterForm.get('postcodeSearch.postcode')?.hasError('invalidValue')">
            {{ meterForm.get('postcodeSearch.postcode')?.getError('errorMessage') }}
          </mat-error>
        </mat-form-field>
        
        <button mat-flat-button type="button" (click)="searchPostcode()" 
                [disabled]="!meterForm.get('postcodeSearch.postcode')?.valid">
          Search
        </button>
      </div>

      <mat-form-field class="w-100 w-md-75" appearance="outline" subscriptSizing="dynamic" *ngIf="addressList.length > 0">
        <mat-label>Select Address</mat-label>
        <mat-select formControlName="address" (selectionChange)="onAddressSelected()">
          <mat-option *ngFor="let address of addressList" [value]="address.addressId">
            {{ address.addressAsLine }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="meterForm.get('postcodeSearch.address')?.hasError('required')">
          Please select an address
        </mat-error>
      </mat-form-field>
    </div>

    <!-- MPAN Search -->
    <div formGroupName="mpanSearch" class="search-section" *ngIf="meterForm.get('searchType')?.value === 'mpan'">
      <h4>MPAN Search</h4>
      
      <div class="form-row">
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>MPAN</mat-label>
          <input matInput formControlName="mpan" placeholder="Enter MPAN">
          <mat-error *ngIf="meterForm.get('mpanSearch.mpan')?.hasError('required')">
            MPAN is required
          </mat-error>
          <mat-error *ngIf="meterForm.get('mpanSearch.mpan')?.hasError('invalidValue')">
            {{ meterForm.get('mpanSearch.mpan')?.getError('errorMessage') }}
          </mat-error>
        </mat-form-field>
        
        <button mat-raised-button type="button" (click)="searchMPAN()" 
                [disabled]="!meterForm.get('mpanSearch.mpan')?.value">
          <mat-spinner *ngIf="fetchingMeterDetails" diameter="20"></mat-spinner>
          <span *ngIf="!fetchingMeterDetails">Search</span>
        </button>
      </div>
    </div>

    <!-- File Upload -->
    <div formGroupName="fileUpload" class="search-section" *ngIf="meterForm.get('searchType')?.value === 'file'">
      <h4>Upload File</h4>
      <p>Upload a CSV file containing multiple MPANs</p>
      <div class="file-upload-section">
        <app-file-input 
          formControlName="file" 
          accept=".csv"
          placeholder="Choose CSV file..."
          buttonLabel="Upload CSV file with MPANs">
        </app-file-input>
        <p class="file-help-text">
          <a href="https://lcr.thelabrador.co.uk/cdn/bulk_onboard.csv" target="_blank" download="sample.csv">
            Download sample CSV file
          </a>
        </p>
      </div>
    </div>

    <!-- Loading Indicator -->
    <div *ngIf="fetchingMeterDetails" class="loading-section">
      <mat-spinner diameter="30"></mat-spinner>
      <p>Fetching meter details...</p>
    </div>
  </form>

  <!-- Selected Meters Display -->
  <div class="selected-meters-section" *ngIf="selectedMeters.length > 0">
    <h4>Selected Meters</h4>
    <div class="meters-list">
      <mat-card *ngFor="let meter of selectedMeters; let i = index" class="meter-card">
        <mat-card-content>
          <div class="meter-info">
            <div class="meter-header">
              <h5>{{ meter.mpanCore }}</h5>
              <button mat-icon-button (click)="removeMeter(i)" [attr.aria-label]="'Remove meter ' + meter.mpanCore">
                <mat-icon>close</mat-icon>
              </button>
            </div>
            <p><strong>Type:</strong> {{ isSmartMeter(meter) ? 'Smart Meter' : 'Half Hourly Meter' }}</p>
            <p><strong>Profile Class:</strong> {{ meter.profileClass }}</p>
            <p *ngIf="meter.addressAsLine"><strong>Address:</strong> {{ meter.addressAsLine }}</p>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>

  <!-- Selected File Display -->
  <div class="selected-file-section" *ngIf="selectedFile">
    <h4>Selected File</h4>
    <mat-card class="file-card">
      <mat-card-content>
        <div class="file-info">
          <mat-icon>description</mat-icon>
          <div class="file-details">
            <p><strong>{{ selectedFile.name }}</strong></p>
            <p class="file-size">{{ (selectedFile.size / 1024).toFixed(2) }} KB</p>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>


  <!-- Help Text -->
  <div class="help-section" *ngIf="selectedMeters.length === 0 && !selectedFile">
    <mat-icon>info</mat-icon>
    <p>
      Search for your meter using postcode, MPAN number, or upload a CSV file with multiple MPANs. 
      Only half-hourly and smart meters are eligible for onboarding.
    </p>
  </div>
</div>
